<template>
  <div style="display: contents;">
  <v-dialog v-model="visible" v-if="receipt" persistent width="500" content-class="payment-change-dialog">
    <v-form ref="paymentChangeForm" @submit.prevent="submit">
      <v-card class="glass-card-payment">
        <v-card-title class="glass-header-payment pa-0">
          <v-row class="ma-0 pa-4 align-center">
            <v-col cols="auto" class="pa-0">
              <v-icon color="white" size="28">mdi-swap-horizontal</v-icon>
            </v-col>
            <v-col class="pa-0 pl-3">
              <h3 class="white--text" style="font-weight: 600; font-size: 18px; letter-spacing: 0.3px;">Način plaćanja</h3>
            </v-col>
            <v-spacer></v-spacer>
            <v-col cols="auto" class="pa-0">
              <v-icon large color="white" @click="close">mdi-close</v-icon>
            </v-col>
          </v-row>
        </v-card-title>
        <v-card-text class="pt-4 px-4 pb-2">
          <v-row>
            <v-col class="pb-2">
              <div class="current-method-label">Trenutni način plaćanja</div>
              <div class="current-method-value">{{ receipt.payment_method }}</div>
            </v-col>
          </v-row>
          <v-row class="mt-2">
            <v-col class="pb-0 mb-0">
              <div class="payment-label-change">Odaberi novi način plaćanja</div>
            </v-col>
          </v-row>
          <v-row class="payment-methods-row-change justify-center">
            <v-col
              v-for="(method, idx) in paymentMethods"
              :key="idx"
              cols="6"
              class="pa-2"
            >
              <v-btn
                block
                elevation="4"
                class="payment-method-btn-change"
                :class="[
                  { 'payment-method-selected-change': selectedPaymentMethod === method.value },
                  getButtonClass(method.value)
                ]"
                @click="selectedPaymentMethod = method.value"
              >
                <div class="btn-content-change">
                  <v-icon size="48" class="mb-2">
                    {{ getIcon(method.value) }}
                  </v-icon>
                  <div class="btn-text-change">{{ getMethodText(method.value) }}</div>
                </div>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="d-flex justify-center px-4 pb-4">
          <v-btn
            outlined
            color="primary"
            @click="close"
            class="cancel-btn-change"
            elevation="0"
          >
            Odustani
          </v-btn>
          <v-btn
            @click="submit"
            class="submit-btn-change"
            elevation="0"
          >
            Završi
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
    <v-overlay v-if="loading" absolute z-index="10">
      <v-progress-circular
        indeterminate
        size="64"
        color="primary"
      ></v-progress-circular>
    </v-overlay>
  </v-dialog>
  <v-snackbar
    v-model="snackbar"
    :timeout="3000"
    :color="snackbarColor"
    top
    right
  >
    <v-icon left color="white">mdi-information</v-icon>
    {{ snackbarText }}
    <template v-slot:action="{ attrs }">
      <v-btn text v-bind="attrs" @click="snackbar = false" color="white">
        Zatvori
      </v-btn>
    </template>
  </v-snackbar>
  </div>
</template>
<script>
import rules from '@/plugins/rules'
import { clone } from '@/plugins/utils'
import { functions } from '@/plugins/firebase'
import state from '@/state'
// import { v4 as uuidv4 } from 'uuid'
export default {
  inject: ['showMsgBox', 'showLoader', 'hideLoader'],
  data: function () {
    return {
      visible: false,
      loading: false,
      receipt: undefined,
      selectedPaymentMethod: undefined,
      paymentMethods: [{
        name: 'Promijeni način plaćanja u novčanice', value: 'N'
      },
      {
        name: 'Promijeni način plaćanja u kartice', value: 'K'
      },
      {
        name: 'Promijeni način plaćanja u ostalo', value: 'O'
      }],
      rules: {
        req: rules.req()
      },
      snackbar: false,
      snackbarText: '',
      snackbarColor: 'info'
    }
  },
  computed: {},
  methods: {
    getIcon (value) {
      switch (value) {
        case 'NOVČANICE':
          return 'mdi-currency-eur'
        case 'KARTICA':
          return 'mdi-credit-card-outline'
        case 'OSTALO':
          return 'mdi-dots-horizontal'
        default:
          return 'mdi-currency-eur'
      }
    },
    getButtonClass (value) {
      switch (value) {
        case 'NOVČANICE':
          return 'cash-btn-change'
        case 'KARTICA':
          return 'card-btn-change'
        case 'OSTALO':
          return 'other-btn-change'
        default:
          return 'cash-btn-change'
      }
    },
    getMethodText (value) {
      switch (value) {
        case 'NOVČANICE':
          return 'GOTOVINA'
        case 'KARTICA':
          return 'KARTICA'
        case 'OSTALO':
          return 'OSTALO'
        default:
          return value
      }
    },
    open (receipt) {
      if (!receipt) return
      this.visible = true
      this.receipt = clone(receipt)

      if (this.receipt.payment_method && this.receipt.payment_method !== '') {
        switch (this.receipt.payment_method) {
          case 'NOVČANICE':
            this.paymentMethods = [
              {
                name: 'Promijeni način plaćanja u kartice', value: 'KARTICA'
              },
              {
                name: 'Promijeni način plaćanja u ostalo', value: 'OSTALO'
              }]
            break
          case 'KARTICA':
            this.paymentMethods = [{
              name: 'Promijeni način plaćanja u novčanice', value: 'NOVČANICE'
            },
            {
              name: 'Promijeni način plaćanja u ostalo', value: 'OSTALO'
            }]
            break
          case 'OSTALO':
            this.paymentMethods = [{
              name: 'Promijeni način plaćanja u novčanice', value: 'NOVČANICE'
            },
            {
              name: 'Promijeni način plaćanja u kartice', value: 'KARTICA'
            }]
            break
        }
      }
    },
    close () {
      this.visible = false
    },
    submit () {
      if (!this.selectedPaymentMethod || this.selectedPaymentMethod === '') return
      var that = this
      this.loading = true
      try {
        var receiptApi = functions.httpsCallable('receiptapi')

        const params = {
          company_id: state.getCurrentCompany().id,
          payment_method: this.selectedPaymentMethod
        }

        receiptApi({
          action: {
            operation: 'update',
            entity: 'payment',
            resource_id: this.receipt.id,
            params: params
          }
        })
          .then(async (doc) => {
            // Provjeri je li došlo do greške
            // Response može biti u formatu: { data: { status: "OK" }, header: { code: 200 } }
            // ili u formatu greške: { data: { code: 575, error: "..." }, header: { code: 575 } }
            const isError = (doc.header && doc.header.code !== 200) ||
                           (doc.data && doc.data.status !== 'OK' && doc.data.code !== 200)

            if (isError) {
              const errorMessage = (doc.data && doc.data.error) ||
                                  (doc.header && doc.header.error) ||
                                  'Promjena načina plaćanja nije uspjela.'
              that.showMsgBox({
                title: 'Neuspješna promjena načina plaćanja',
                text: errorMessage,
                actions: ['cancel'],
                cancelBtnText: that.$t('$vuetify.close'),
                color: 'error'
              })
              that.loading = false
              return
            }

            // Uspješna promjena
            that.receipt.payment_method = that.selectedPaymentMethod
            that.$emit('reprintReceipt', that.receipt)
            that.loading = false
            that.snackbarText = 'Uspješno promijenjen način plaćanja.'
            that.snackbarColor = 'info'
            that.snackbar = true
            that.close()
          }
          )
      } catch (err) {
        this.showMsgBox({
          text: err,
          actions: ['cancel'],
          cancelBtnText: 'OK'
        })
      }
    }
  }
}
</script>

<style scoped>
/* Glass Card with Brand Gradient Header */
.glass-card-payment {
  background: rgba(255, 255, 255, 0.95) !important;
  backdrop-filter: blur(20px) !important;
  border-radius: 16px !important;
  border: 1px solid rgba(0, 179, 190, 0.2) !important;
  box-shadow: 0 8px 32px rgba(0, 179, 190, 0.15) !important;
  overflow: hidden;
}

.glass-header-payment {
  background: linear-gradient(135deg,
    rgba(0, 179, 190, 0.9) 0%,
    rgba(57, 137, 201, 0.85) 50%,
    rgba(97, 84, 164, 0.9) 100%) !important;
  position: relative;
}

/* Current Method Display */
.current-method-label {
  font-size: 12px;
  color: rgba(57, 137, 201, 0.8);
  font-weight: 500;
  letter-spacing: 0.3px;
  text-transform: uppercase;
  margin-bottom: 4px;
}

.current-method-value {
  font-weight: 700;
  color: rgba(70, 70, 80, 0.9);
  font-size: 18px;
  padding: 12px;
  background: rgba(57, 137, 201, 0.08);
  border-radius: 8px;
  border: 1px solid rgba(57, 137, 201, 0.2);
  text-align: center;
}

/* Payment Methods Section */
.payment-label-change {
  font-size: 13px;
  font-weight: 600;
  color: rgba(57, 137, 201, 0.8);
  letter-spacing: 0.3px;
  text-transform: uppercase;
  margin-bottom: 8px;
}

.payment-methods-row-change {
  margin-top: 4px;
}

/* Payment Method Buttons */
.payment-method-btn-change {
  border-radius: 16px !important;
  border: 2px solid rgba(255, 255, 255, 0.4) !important;
  backdrop-filter: blur(10px) !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
  text-transform: none !important;
  padding: 24px 16px !important;
  min-height: 180px !important;
  position: relative;
}

.btn-content-change {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
}

.btn-text-change {
  font-size: 18px !important;
  font-weight: 700 !important;
  letter-spacing: 1px !important;
  color: white !important;
}

/* Cash Button (Blue) */
.cash-btn-change {
  background: linear-gradient(135deg,
    rgba(44, 90, 144, 0.95) 0%,
    rgba(33, 67, 108, 0.9) 100%) !important;
  box-shadow: 0 8px 24px rgba(44, 90, 144, 0.4) !important;
}

.cash-btn-change:hover:not(:disabled) {
  background: linear-gradient(135deg,
    rgba(44, 90, 144, 1) 0%,
    rgba(33, 67, 108, 1) 100%) !important;
  box-shadow: 0 12px 32px rgba(44, 90, 144, 0.6) !important;
  transform: translateY(-8px) scale(1.05);
  border-color: rgba(255, 255, 255, 0.6) !important;
}

/* Card Button (Cyan) */
.card-btn-change {
  background: linear-gradient(135deg,
    rgba(59, 120, 195, 0.95) 0%,
    rgba(41, 91, 144, 0.9) 100%) !important;
  box-shadow: 0 8px 24px rgba(59, 120, 195, 0.4) !important;
}

.card-btn-change:hover:not(:disabled) {
  background: linear-gradient(135deg,
    rgba(59, 120, 195, 1) 0%,
    rgba(41, 91, 144, 1) 100%) !important;
  box-shadow: 0 12px 32px rgba(59, 120, 195, 0.6) !important;
  transform: translateY(-8px) scale(1.05);
  border-color: rgba(255, 255, 255, 0.6) !important;
}

/* Other Button (Purple) */
.other-btn-change {
  background: linear-gradient(135deg,
    rgba(97, 84, 164, 0.95) 0%,
    rgba(72, 63, 123, 0.9) 100%) !important;
  box-shadow: 0 8px 24px rgba(97, 84, 164, 0.4) !important;
}

.other-btn-change:hover:not(:disabled) {
  background: linear-gradient(135deg,
    rgba(97, 84, 164, 1) 0%,
    rgba(72, 63, 123, 1) 100%) !important;
  box-shadow: 0 12px 32px rgba(97, 84, 164, 0.6) !important;
  transform: translateY(-8px) scale(1.05);
  border-color: rgba(255, 255, 255, 0.6) !important;
}

.payment-method-btn-change .v-icon {
  color: white !important;
  filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.3));
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

.payment-method-btn-change:hover .v-icon {
  transform: scale(1.1);
  filter: drop-shadow(0 6px 12px rgba(0, 0, 0, 0.4));
}

/* Selected State */
.payment-method-selected-change {
  transform: translateY(-4px) scale(1.02) !important;
  border-width: 3px !important;
  border-color: rgba(255, 255, 255, 0.8) !important;
}

.cash-btn-change.payment-method-selected-change {
  box-shadow: 0 12px 32px rgba(44, 90, 144, 0.7),
              0 0 0 4px rgba(44, 90, 144, 0.2) !important;
}

.card-btn-change.payment-method-selected-change {
  box-shadow: 0 12px 32px rgba(59, 120, 195, 0.7),
              0 0 0 4px rgba(59, 120, 195, 0.2) !important;
}

.other-btn-change.payment-method-selected-change {
  box-shadow: 0 12px 32px rgba(97, 84, 164, 0.7),
              0 0 0 4px rgba(97, 84, 164, 0.2) !important;
}

.payment-method-selected-change .v-icon {
  transform: scale(1.15) !important;
  filter: drop-shadow(0 6px 12px rgba(0, 0, 0, 0.5)) !important;
}

.payment-method-selected-change .btn-text-change {
  transform: scale(1.05);
}

/* Cancel Button */
.cancel-btn-change {
  background: rgba(255, 255, 255, 0.9) !important;
  color: #3989C9 !important;
  border: 1px solid rgba(57, 137, 201, 0.25) !important;
  border-radius: 12px !important;
  box-shadow: 0 2px 8px rgba(57, 137, 201, 0.12) !important;
  backdrop-filter: blur(10px) !important;
  text-transform: none !important;
  font-weight: 600 !important;
  font-size: 14px !important;
  letter-spacing: 0.3px !important;
  padding: 10px 24px !important;
  height: 40px !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

.cancel-btn-change:hover {
  background: rgba(255, 255, 255, 1) !important;
  border-color: #3989C9 !important;
  box-shadow: 0 4px 12px rgba(57, 137, 201, 0.25) !important;
  transform: translateY(-1px);
}

/* Submit Button */
.submit-btn-change {
  background: linear-gradient(135deg,
    rgba(76, 175, 80, 0.95) 0%,
    rgba(56, 142, 60, 0.9) 100%) !important;
  color: white !important;
  border-radius: 12px !important;
  border: 1px solid rgba(255, 255, 255, 0.3) !important;
  box-shadow: 0 4px 12px rgba(76, 175, 80, 0.25) !important;
  backdrop-filter: blur(10px) !important;
  text-transform: none !important;
  font-weight: 700 !important;
  font-size: 14px !important;
  letter-spacing: 0.3px !important;
  padding: 10px 24px !important;
  height: 40px !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

.submit-btn-change:hover {
  background: linear-gradient(135deg,
    rgba(76, 175, 80, 1) 0%,
    rgba(56, 142, 60, 1) 100%) !important;
  transform: translateY(-2px) scale(1.02);
  box-shadow: 0 8px 20px rgba(76, 175, 80, 0.4) !important;
  border-color: rgba(255, 255, 255, 0.5) !important;
}

/* Dialog Border Radius */
.payment-change-dialog {
  border-radius: 16px !important;
}
</style>
